import { AgentUserFacade, Position } from '@contact/upgrade';

const MODULE_NAME = 'positionDeprecatedService';

/**
 * @deprecated prefer PositionFacade
 */
export interface IPositionDeprecatedService {
  /**
   * @deprecated prefer PositionFacade.position$
   */
  position: Position | undefined;

  /**
   * @deprecated prefer PositionFacade.position$
   */
  hasPosition(): boolean;
}

/**
 * @deprecated prefer PositionFacade
 */
export class PositionDeprecatedService implements IPositionDeprecatedService {
  static $inject: Array<string> = ['agentUserFacade'];

  /**
   * @deprecated prefer PositionFacade.position$
   */
  position: Position | undefined = undefined;

  constructor(private readonly agentUserFacade: AgentUserFacade) {
    this.agentUserFacade.position$.subscribe(position => (this.position = position));
  }

  /**
   * @deprecated prefer PositionFacade.position$
   */
  hasPosition(): boolean {
    return !!this.position && !!this.position.id;
  }
}

export default MODULE_NAME;
